import React from 'react';
import './Section.scss';

const Section = ({children, type = 'normal'}) => {
  return <section className={`section section--${type}`}>{children}</section>;
};

export default Section;
